import { makeStyles } from "tss-react/mui";

import { controlSurface } from "@/shared/styles/action.styles";

const useStyles = makeStyles()((theme) => ({
  formControl: {
    ...controlSurface(theme),
    minWidth: 60,
    margin: 0,
    borderRadius: theme.design.radius.md,

    "& .MuiInputBase-root": {
      height: "24.5px",
      fontSize: "13px",
      color: theme.design.color.text.primary,

      "&.Mui-disabled": {
        "& svg": {
          color: `${theme.design.color.text.muted}!important`,
        },
      },

      "& .MuiSelect-select": {
        textAlign: "center",
        fontFamily: theme.design.typography.fontFamily,

        "& img": {
          display: "none",
        },
      },

      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },

      "& .MuiSvgIcon-root, & .MuiSelect-icon, & svg": {
        color: theme.design.color.text.primary,
      },
    },
    "& .MuiMenu-paper": {
      padding: "0",
      display: "block",
      minWidth: "auto",
    },
  },
  detail: {
    display: "flex",
    gap: theme.design.space.sm,
    alignItems: "center",
    justifyContent: "center",
  },
  menuItem: {
    position: "relative",
    minHeight: "36px!important",
    margin: `${theme.design.space.xxs}px 0`,
    padding: `${theme.design.space.sm}px ${theme.design.space.md}px ${theme.design.space.sm}px ${theme.design.space.lg}px`,
    overflow: "hidden",
    border: "none",
    borderRadius: theme.design.radius.sm,
    backgroundColor: theme.design.color.overlay.transparent,
    color: theme.design.color.text.muted,
    fontFamily: theme.design.typography.fontFamily,
    fontSize: theme.design.typography.size.bodySmall,
    fontWeight: 700,
    lineHeight: theme.design.typography.lineHeight.compact,
    transition: [
      `background-color ${theme.design.motion.duration.fast} ${theme.design.motion.easing.standard}`,
      `color ${theme.design.motion.duration.fast} ${theme.design.motion.easing.standard}`,
      `transform ${theme.design.motion.duration.fast} ${theme.design.motion.easing.standard}`,
    ].join(", "),

    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },

    "&::before": {
      content: '""',
      position: "absolute",
      top: theme.design.space.sm,
      bottom: theme.design.space.sm,
      left: theme.design.space.xs,
      width: 3,
      borderRadius: theme.design.radius.pill,
      background: theme.design.gradient.action.primary,
      opacity: 0,
      transform: "scaleY(0.35)",
      transition: [
        `opacity ${theme.design.motion.duration.fast} ${theme.design.motion.easing.standard}`,
        `transform ${theme.design.motion.duration.fast} ${theme.design.motion.easing.emphasized}`,
      ].join(", "),

      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
      },
    },

    "&:hover, &.Mui-focusVisible": {
      backgroundColor: theme.design.color.surface.controlHover,
      color: theme.design.color.text.primary,
      transform: `translateX(${theme.design.space.xxs}px)`,
    },

    "&.Mui-selected": {
      backgroundColor: theme.design.color.overlay.white10,
      color: theme.design.color.text.primary,

      "&::before": {
        opacity: 1,
        transform: "scaleY(1)",
      },

      "&:hover, &.Mui-focusVisible": {
        backgroundColor: theme.design.color.surface.controlHover,
      },
    },

    "&.Mui-disabled": {
      color: theme.design.color.text.secondary,
      opacity: theme.design.opacity.disabled,
    },

    "& > .MuiBox-root": {
      width: "100%",
      justifyContent: "flex-start",
    },
  },
  menuPaper: {
    maxHeight: 320,
    marginTop: theme.design.space.xs,
    padding: theme.design.space.xs,
    border: `1px solid ${theme.design.color.border.popover}`,
    borderRadius: theme.design.radius.lg,
    background: `linear-gradient(180deg, ${theme.design.color.surface.interactive} 0%, ${theme.design.color.surface.popover} 100%)`,
    color: theme.design.color.text.primary,
    boxShadow: `${theme.design.shadow.dropdown}, inset 0 1px 0 ${theme.design.color.overlay.white10}`,
    overflowY: "auto",
    scrollbarColor: `${theme.design.color.border.popover} transparent`,
    scrollbarWidth: "thin",

    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "inherit",
      pointerEvents: "none",
    },

    "&::-webkit-scrollbar": {
      width: 6,
    },

    "&::-webkit-scrollbar-thumb": {
      borderRadius: theme.design.radius.pill,
      backgroundColor: theme.design.color.border.popover,
    },
  },
  menuList: {
    padding: 0,
  },

  placeholder: {
    position: "absolute",
    lineHeight: "24.5px",
    paddingLeft: theme.design.space.lg,
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
  },
}));

export default useStyles;
